<uni-text-caption
  [weight]="fontWeight"
  [color]="fontColor"
  [isUppercase]="false"
>
  <ng-content></ng-content>
</uni-text-caption>
